import React from 'react';
import PropTypes from 'prop-types';
import dateFormatService from '../services/DateFormatService';

const FormattedDateShort = ({ value, className, showTimeInTooltip }) => {
  const stringValue = value instanceof Date ? value.toISOString() : value;
  const title = showTimeInTooltip ? dateFormatService.formatDateWithTime(stringValue) : undefined;
  return (
    <span className={className} title={title}>
      {dateFormatService.formatDate(stringValue)}
    </span>
  );
};

FormattedDateShort.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  showTimeInTooltip: PropTypes.bool,
};
FormattedDateShort.defaultProps = {
  className: '',
  showTimeInTooltip: false,
};
export default FormattedDateShort;
